
import React from 'react';

import PropTypes from 'prop-types';
import { /* NavLink as RouterLink, */ useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  List,
  ListItem,
  ListItemText,
  styled,
  ListItemIcon,
  ListItemButton,
  Collapse,
  Divider,
  Typography,
  Link
} from '@mui/material';

import { grey } from '@mui/material/colors';
//
// import { StyledNavItem, StyledNavItemIcon } from './styles';

import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';

import { CommonIcons, icons } from '../../components/common/CommonIcons';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  // width: 22,
  // height: 22,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

// ----------------------------------------------------------------------

SidebarNav.propTypes = {
  data: PropTypes.array,
};

export default function SidebarNav({ data = [], t, ...other }) {

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 0 }}>
        {data.map((item) => (
          <NewNavItem
            key={
              item.title
            }
            item={item}
            // translations={translationSidebar}
            t={t}
          />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------


const styles = 
  {
    appMenu: {
      width: '100%',
    },
    navList: {
      // width: drawerWidth,
    },
    menuItem: {
      // width: drawerWidth,
      // width: '100%',
      // backgroundColor: 'red'
      pl: 1,
      pr: 2,
      py: 1
    },
    menuItemIcon: {
      color: 'primary',
    },
    menuItemText: {
      fontSize: 15,
    },
    menuItemSub: {
      py: 0.5,
    },
    menuItemSubText: {
      fontSize: 14,
    },
    expandButton: {
      color: grey[400]
    },
    subMenu: {
      backgroundColor: grey[200]
    }
  }

function NewNavItem({ item, t, onExpand }){

  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false)

  const { getRoute } = useSystemRoutes(routeTypes.driver)

  const { title, path, icon, info, children } = item;

  const handleExpand = ({ open }) => { setOpen(!open) }

  const translateTitle = (title) => {
    let a = t(title)
    return `${a}`
  }
  const navigateTo = (to, toParams = null, onClick) => {
    if(onClick) onClick();
    
    if(to){
      
      if(toParams){
        navigate(getRoute(to), {
          state: toParams
        })
      }else{
        
        navigate(getRoute(to))
      }

    }
  }

  const RenderExpandButton = () => {

    if(!children) return <></>
    if(children.length <= 0) return <></>

    return (
      <Box onClick={() => handleExpand({ open }) } sx={{ justifyContent: 'center', alignItems: 'center' }}>
      {
          open ?
            <CommonIcons name={icons.chevronUp} sx={styles.expandButton} />
            :
            <CommonIcons name={icons.chevronDown} sx={styles.expandButton} />
        }
      </Box>
    )

  }

  const RenderCollapse = () => {

    if(!children) return <></>
    if(children.length <= 0) return <></>

    return (
      <Collapse in={open} timeout="auto" unmountOnExit sx={styles.subMenu}>
        {/* <Divider /> */}
        <List component="div" disablePadding>
          {
            children.map((i, index) => {

              return (
                <ListItem 
                  key={index} 
                  disablePadding 
                  button 
                  sx={[styles.menuItem, styles.menuItemSub]} 
                  onClick={() => navigateTo(i.path)}
                  
                >
                  <Box
                    sx={{
                      // backgroundColor: 'red',
                      width: '100%',
                      display: "flex",
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <ListItemText 
                      inset 
                      disableTypography 
                      primary={
                        <Typography sx={styles.menuItemSubText}>
                          {/* {i.title} */}
                          {
                            translateTitle(i?.title)
                          }
                        </Typography>
                      } 
                    />
                    {
                      i?.allowOpenNew &&
                      <Link
                          // component="button"
                          underline="hover"
                          variant="body2"
                          rel="noopener"
                          target="_blank"
                          href={getRoute(i.path)}
                          padding={0}
                          color={"primary"}
                      >
                          <CommonIcons name={icons.redirect} sx={{ width: 13, height: 13, ml: 1, mt: 0.5 }} />
                      </Link>
                    }
                  </Box>
                </ListItem>
              )
            })
          }
          {/* <ListItem disablePadding button sx={styles.menuItem}>
            <ListItemText inset primary="Nested Page 2" />
          </ListItem> */}
        </List>
      </Collapse>
    )
  }

  return (
    <>
    <ListItem 
      button 
      disablePadding 
      sx={styles.menuItem} 
      onClick={() => {

        if (
          children && children.length > 0
        ) {
          handleExpand({ open })
          return false
        }

        navigateTo(path)
        return true
      }}
    >
      <ListItemIcon 
        sx={styles.menuItemIcon}>
        {/* <IconBarChart /> */}
        <StyledNavItemIcon>
          {icon && icon}
        </StyledNavItemIcon>
      </ListItemIcon>
      <ListItemText 
        primary={
          <Typography sx={styles.menuItemText}>
            {/* {title} */}
            {
                translateTitle(title)
              }
          </Typography>
        } 
      />

      {
        RenderExpandButton()
      }

    </ListItem>

    {
      RenderCollapse()
    }

    </>
  )
}
